class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.content = this.querySelector('.header__modal-content');
    this.shippingBar = document.querySelector('.shipping-bar');
    this.headerModals = document.querySelectorAll('.header__modal-content');

    this.facetsWrapper = this.querySelector('.facets-modal__wrapper');
    this.facetsActions = this.querySelector('.active-facets-desktop');
    this.footer = document.querySelector('footer');
    this.container = document.querySelector('.facets-container');
    this.collectionWrapper = document.querySelector('.collection-wrapper');
    this.toggleButtons = this.querySelectorAll('button[type="button"][aria-label="Close"]');
    this.falseSearch = this.querySelector('.js-false-search');
    this.searchDetails = document.querySelector('.header__modal--search details');

    if (this.falseSearch != null && this.searchDetails != null) {
      this.falseSearch.addEventListener('click', (event) => {
        this.searchDetails.setAttribute('open', true);
      });
    };

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close(),
    );

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this),
    );

    this.toggleButtons.forEach(toggleButton => {
      toggleButton.addEventListener(
        'click',
        this.close.bind(this),
      );
    });

    this.summaryToggle.setAttribute('role', 'button');

    window.addEventListener('load', () => {
      this.calculatePosition();
    });

    window.addEventListener('resize', () => {
      this.calculatePosition();
    });

    window.addEventListener('scroll', () => {
      this.handleScroll()
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  calculateMaxHeight() {
    const facetsParent      = this.closest('.facets-wrapper');
    const facetsContainer   = this.querySelector('.facets-wrapper .facets-container');
    const facetsButtons     = this.querySelector('facet-filters-form .active-facets');

    if (facetsParent != null && facetsContainer != null) {
      const rect = facetsParent.getBoundingClientRect();
      let containerOffset = 0;
      let facetsButtonsHeight = 0;
      let topPosition = 0;

      if (window.innerWidth >= 990) {
        topPosition = Math.round(rect.top);
      }

      if (facetsButtons != null) {
        facetsButtonsHeight = Math.round(facetsButtons.offsetHeight);
      };

      containerOffset = topPosition + facetsButtonsHeight;

      facetsContainer.style.maxHeight = `calc(100vh - ${containerOffset}px)`
    };
  }

  onBodyClick(event) {
    this.hasShippingBar();

    if (
      !this.contains(event.target) ||
      event.target.classList.contains('modal-overlay')
    )
      this.close(false);
  }

  hasShippingBar() {
    this.headerModals.forEach(headerModal => {
      headerModal.classList.remove('has-shipping-bar');

      if (this.shippingBar != null) {
        if (!this.shippingBar.classList.contains('shipping-bar--hidden') && !document.querySelector('.header-group').classList.contains('scrolled-past-header')) {
          headerModal.classList.add('has-shipping-bar');
        }
      };
    });
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    if (document.querySelector('.header-wrapper')) {
      if (this.classList.contains('header__modal--nav')) {
        document.querySelector('.header-wrapper').classList.add('header--open');

        this.hasShippingBar()
      };
    };

    if (!this.querySelector('.facets')) {
      document.body.classList.add('overflow-hidden');
    };

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );

    setTimeout(() => {
      this.calculatePosition();
    }, 400);
  }

  isFooterInView() {
    const rect = this.footer.getBoundingClientRect();
    return rect.top <= window.innerHeight && rect.bottom >= 0;
  }

  handleScroll() {
    if (this.facetsActions != null) {
      const visibleFooterHeight = (window.innerHeight - this.footer.getBoundingClientRect().top) + 10;

      if (this.isFooterInView()) {
        this.facetsActions.classList.add('fixed');
        this.facetsActions.style.bottom = `${visibleFooterHeight}px`;
      } else {
        this.facetsActions.classList.remove('fixed');
        this.facetsActions.style.bottom = '0';
      }
    };
  }

  calculatePosition() {
    if (this.facetsActions != null) {
      const rect            = this.facetsWrapper.getBoundingClientRect();
      const spaceFromLeft   = rect.left+14;

      this.facetsActions.style.left = `${spaceFromLeft}px`;
    };

    setTimeout(() => {
      this.calculatePosition();
    }, 100);

    if (this.container && this.collectionWrapper) {
      this.container.style.maxHeight = `${this.collectionWrapper.innerHeight}px`
    };
  }

  close(focusToggle = true) {
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    if (document.querySelector('.header-wrapper')) {
      if (this.classList.contains('header__modal--nav')) {
        document.querySelector('.header-wrapper').classList.remove('header--open');
      };
    };
  }
}

customElements.define('details-modal', DetailsModal);
